// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"vendors-node_modules_notino_react-styleguide_dist_es_ActionButton_js-node_modules_notino_reac-fa7aa5":"68a7a57b55279ef1b0fe","AppLayout":"dcbf95ec6c5f89c57773"}[chunkId] + ".chunk.js";
};